import { TherapistAction } from 'src/redux/actions/constant';

const {
  THERAPIST_AUTO_MATCHING_FAILURE,
  THERAPIST_AUTO_MATCHING_RESET,
  THERAPIST_AUTO_MATCHING_SUCCESS,
  THERAPIST_AUTO_MATCHING_LOADING,
} = TherapistAction;
const intialState: object = {
  response: null,
  errorMessage: null,
  isTaskAssigned: false,
  loading: false,
};

export const autoMatchingThearpistReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case THERAPIST_AUTO_MATCHING_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        errorMessage: null,
        isTaskAssigned: true,
        loading: false,
      };
    }
    case THERAPIST_AUTO_MATCHING_FAILURE: {
      return {
        ...state,
        response: null,
        errorMessage: action.payload,
        isTaskAssigned: false,
        loading: false,
      };
    }

    case THERAPIST_AUTO_MATCHING_RESET:
      return intialState;
    case THERAPIST_AUTO_MATCHING_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};
